export default __webpack_public_path__ + "portfolio06.jpg";